import React, { useEffect, useState } from 'react';
import './App.css';
import * as d3 from 'd3';
import { OrgChartComponent } from './OrgChart';
import { Data } from './data';

function App() {
  const [data, setData] = useState<d3.DSVRowArray<string>>(Data as unknown as d3.DSVRowArray<string>);

  function onNodeClick(nodeId: string) {
    // console.log('d3', d3.event);
    alert('clicked ' + nodeId);
  }

  return <OrgChartComponent
    data={data}
  />

}

export default App;
